import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

// Interfaces
import { IComponent } from '../../interfaces';

// Services
import * as srv from '../../../share/services';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements IComponent, OnInit, OnDestroy {
  // Implement IComponent
  name = 'MenuComponent';
  subscriptions: Subscription[] = [];

  // Implement local variable
  // *

  constructor(
    private _logSrv: srv.LogService,
    private _userSrv: srv.UserService,
    private _loaderSrv: srv.LoaderService
  ) {

    this.subscriptions.push(
      this._userSrv.CONTACT.subscribe(contact => {
        'updating contact'.logWithObject(this.name, contact);
        // if (contact !== undefined) {
        //   this._userSrv.getAccountContacts(contact.AcepId, contact.Id);
        // } else {
        //   this._userSrv.accountContacts = undefined;
        // }
      }));


  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
    delete this.subscriptions;
  }




}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/menu/menu.component.ts